/**
 * New alias for the backend experiments
 *
 * show|hide will apply to all visibility experiments
 * show1|show2|hide1|hide2 apply to embed_visibility_aabb
 */

import type { BackendExperiment } from './types'

const experiment_aliases: Record<string, BackendExperiment> | null = {
  firework_show: {
    experiment_id: 'firework_visibility',
    base_experiment_type: 'firework_visibility',
    variant_value: 'show',
    name: `URL Override: firework_visibility`,
    variant_properties: {},
  },
  firework_hide: {
    experiment_id: 'firework_visibility',
    base_experiment_type: 'firework_visibility',
    variant_value: 'hide',
    name: `URL Override: firework_visibility`,
    variant_properties: {},
  },
  widget_show: {
    experiment_id: 'embed_visibility',
    base_experiment_type: 'embed_visibility',
    variant_value: 'show',
    name: `URL Override: embed_visibility`,
    variant_properties: {},
  },
  widget_hide: {
    experiment_id: 'embed_visibility',
    base_experiment_type: 'embed_visibility',
    variant_value: 'hide',
    name: `URL Override: embed_visibility`,
    variant_properties: {},
  },
  widget_show1: {
    experiment_id: 'embed_visibility_aabb',
    base_experiment_type: 'embed_visibility_aabb',
    variant_value: 'show1',
    name: `URL Override: embed_visibility_aabb`,
    variant_properties: {},
  },
  widget_show2: {
    experiment_id: 'embed_visibility_aabb',
    base_experiment_type: 'embed_visibility_aabb',
    variant_value: 'show2',
    name: `URL Override: embed_visibility_aabb`,
    variant_properties: {},
  },
  widget_hide1: {
    experiment_id: 'embed_visibility_aabb',
    base_experiment_type: 'embed_visibility_aabb',
    variant_value: 'hide1',
    name: `URL Override: embed_visibility_aabb`,
    variant_properties: {},
  },
  widget_hide2: {
    experiment_id: 'embed_visibility_aabb',
    base_experiment_type: 'embed_visibility_aabb',
    variant_value: 'hide2',
    name: `URL Override: embed_visibility_aabb`,
    variant_properties: {},
  },
  ava_show: {
    experiment_id: 'ava_visibility',
    base_experiment_type: 'ava_visibility',
    variant_value: 'show',
    name: `URL Override: ava_visibility`,
    variant_properties: {},
  },
  ava_hide: {
    experiment_id: 'ava_visibility',
    base_experiment_type: 'ava_visibility',
    variant_value: 'hide',
    name: `URL Override: ava_visibility`,
    variant_properties: {},
  },
}

/**
 *
 * @param alias
 * @returns
 */
export const getExperimentByAlias = (
  alias: string,
): BackendExperiment | null => {
  if (!alias) {
    return null
  }

  const experiment = experiment_aliases[alias]

  return experiment || null
}
